import { TachographTimeline } from "../models/Tachograph";
import { DAY_MS, formatDateTime, formatUtcDateTime } from "./tachographDates";

type TranslateCount = (key: string, options: { count: number }) => string;

/**
 * Builds the deadline texts from the last readout: when the next one is due,
 * in local time and in UTC, plus how many days are left or missed.
 */
export function buildTimeline(
  referenceDate: Date | null,
  updateDate: Date | null,
  intervalDays: number,
  language: string,
  now: Date,
  t: TranslateCount,
): TachographTimeline {
  const updateTime = updateDate ? formatDateTime(updateDate, language) : "";

  if (!referenceDate) {
    return { legalLimit: "", nextDownloadUtc: "", calibrationExpiryDate: "", updateTime };
  }

  const dueDate = new Date(referenceDate.getTime() + intervalDays * DAY_MS);
  const daysUntilDue = Math.round((dueDate.getTime() - now.getTime()) / DAY_MS);
  const isDue = daysUntilDue >= 0;
  const count = Math.abs(daysUntilDue);

  const dueLabel = isDue
    ? t("tachograph.daysLeft", { count })
    : t("tachograph.daysOverdue", { count });
  const utcLabel = isDue
    ? t("tachograph.scheduledIn", { count })
    : t("tachograph.overdueBy", { count });

  return {
    legalLimit: `${formatDateTime(dueDate, language)} | ${dueLabel}`,
    nextDownloadUtc: `${formatUtcDateTime(dueDate)} | ${utcLabel}`,
    calibrationExpiryDate: "",
    updateTime,
  };
}
